import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from "../../../lib/utils";
import LucideIcon from '../LucideIcon';

const SobaVerticalNavExpansionPanel = ({ item, children, mode }) => {
  const [collapsed, setCollapsed] = useState(true);
  const elementRef = useRef(null);
  const componentHeight = useRef(0);
  const { pathname } = useLocation();
  const { name, icon, iconText, badge } = item;

  const handleClick = () => {
    componentHeight.current = 0;
    calcaulateHeight(elementRef.current);
    setCollapsed(!collapsed);
  };

  const calcaulateHeight = useCallback((node) => {
    if (!node) return;
    if (node.getAttribute && node.getAttribute('name') !== 'child') {
      for (let child of node.children) {
        calcaulateHeight(child);
      }
    }

    if (node.getAttribute && node.getAttribute('name') === 'child') {
      componentHeight.current += node.scrollHeight;
    } else {
      componentHeight.current += 44; 
    }
  }, []);

  useEffect(() => {
    if (!elementRef.current) return;

    calcaulateHeight(elementRef.current);

    // OPEN DROPDOWN IF CHILD IS ACTIVE
    for (let child of elementRef.current.children) {
      if (child.getAttribute('href') === pathname) {
        setCollapsed(false);
      }
    }
  }, [pathname, calcaulateHeight]);

  return (
    <div className={cn("w-full transition-all duration-300 ease-in-out", mode === 'compact' && "w-[44px] overflow-hidden")}>
      <button
        type="button"
        className={cn(
          "flex w-full h-[44px] items-center justify-between px-4 py-2 mb-2 rounded-md transition-colors hover:bg-white/10 group overflow-hidden whitespace-nowrap",
          !collapsed && "open",
          mode === 'compact' && "px-2 justify-center"
        )}
        onClick={handleClick}
      >
        <div className="flex items-center gap-4">
          {icon && <LucideIcon name={icon} className="shrink-0 text-white/70 group-hover:text-white" />}
          {iconText && <div className="w-1 h-1 rounded-full bg-white ml-5 mr-2 shrink-0" />}
          <span className={cn(
            "text-sm font-medium text-white/70 group-hover:text-white transition-opacity duration-300",
            mode === 'compact' && "opacity-0 invisible w-0"
          )}>
            {name}
          </span>
        </div>

        {badge && (
          <div className={cn(
            "px-2 py-0.5 rounded-full bg-primary-foreground text-primary text-[10px] font-bold",
            mode === 'compact' && "hidden"
          )}>
            {badge.value}
          </div>
        )}

        <div className={cn(
          "transition-transform duration-300",
          !collapsed && "rotate-90",
          mode === 'compact' && "hidden"
        )}>
          <ChevronRight className="h-4 w-4 text-white/50" />
        </div>
      </button>

      <div
        ref={elementRef}
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ maxHeight: collapsed ? '0px' : '1000px' }} // Simplified maxHeight for better reliability
      >
        {children}
      </div>
    </div>
  );
};

export default SobaVerticalNavExpansionPanel;

